import { MaskedFieldInputEvent } from '@cof/fs-masked-field-manager-base';
export const ssnFieldEventType = {
    'ssn-field-change': 'ssn-field-change'
};
export class SsnFieldInputEvent extends MaskedFieldInputEvent {
    /* c8 ignore next 14 - NOTE: C8 not properly covering constructor */
    constructor(validityState, maskedValue, unmaskedValue, originalTarget) {
        super(ssnFieldEventType['ssn-field-change'], validityState, maskedValue, unmaskedValue, originalTarget);
    }
}
//# sourceMappingURL=SsnFieldEvent.js.map